import type { User } from '@/types/users'
import api from './http'

export type UserUpdatePayload = Partial<User> & {
    password?: string
}

export async function getCurrentUser(): Promise<User> {
    return (await api.get('/users/me?populate=role')).data as User
}

export async function updateUserById(userId: number, data: UserUpdatePayload): Promise<User> {
    return (await api.put<User>(`/users/${userId}`, data)).data
}
